import React from 'react';
import classes from "./BattleRatingDiv.module.css";
import RatingBar from '../UI/RatingBar';
import bArrow from "../../../assets/Game/chartbtn/back-arr.png";
import fArrow from "../../../assets/Game/chartbtn/forward-arr.png";
import dice from "../../../assets/Game/chartbtn/dice-roll.gif";

interface BattleRatingDivProps {
    nextClick: () => void;
    prevClick: () => void;
    addMechStats: (mech: any) => Promise<void>;
  currentMech: any;
  total: number;
}

const BattleRatingDiv:React.FC<BattleRatingDivProps> = ({currentMech, nextClick, prevClick, addMechStats, total}) => {    
    
  return (
    <div className={classes["battle-rating-div-bg"]}>
      <div className={classes["battle-rating-div"]}>
        <div className={classes["battle-mash-img"]}>
          <img src={currentMech.imageUrl} alt="Mesh NFT" />
        </div>

        <div className={classes["battle-stats"]}>
          <RatingBar name="Strength" rating={currentMech.strength} />
          <RatingBar name="Agility" rating={currentMech.agility} />
          <RatingBar name="Durability" rating={currentMech.durability} />
          <RatingBar name="Efficiency" rating={currentMech.efficiency} />
          <RatingBar name="Pilot Skills" rating={currentMech.pilotSkills} />
        </div>
      </div>

      <div className={classes["battle-rating-control"]}>
        <div className={classes["dice-img"]}>
          <img src={dice} onClick={() => {
            addMechStats(currentMech)
          }} alt="Dice gif" />
        </div>
        {total > 1 && <div className={classes["arrow-img"]} >
          <span onClick={() => {
            prevClick()
          }}>
            <img src={bArrow} alt="arrow btn" />
          </span>
          <span onClick={() => {
            nextClick()
          }}>
            <img src={fArrow} alt="arrow btn" />
          </span>
        </div>}
      </div>
    </div>
  )
}

export default BattleRatingDiv